import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Box, VStack, FormHelperText } from '@chakra-ui/react';
import { StarIcon } from '@outdoorly/icons';
import { IconButton } from '@outdoorly/button';
import { Text } from '@outdoorly/text';

var Star = function Star(props) {
  return /*#__PURE__*/React.createElement(Box, {
    display: "table-cell"
  }, /*#__PURE__*/React.createElement(StarIcon, props));
};
/**
 * A Read-only star rating component
 */
var StarRating = function StarRating(_ref) {
  var _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? 0 : _ref$rating,
    size = _ref.size;
  var width = "".concat(rating / 5 * 100, "%");
  var backgroundProps = {
    width: size,
    height: size,
    color: 'scheme.controlDisabled',
    fill: 'scheme.controlDisabled'
  };
  var foregroundProps = {
    width: size,
    height: size,
    color: 'scheme.controlActive',
    fill: 'scheme.controlActive'
  };
  return /*#__PURE__*/React.createElement(Box, {
    "aria-label": "Rated ".concat(rating, " stars")
  }, /*#__PURE__*/React.createElement(Box, {
    "float": "left",
    position: "relative"
  }, /*#__PURE__*/React.createElement(Star, backgroundProps), /*#__PURE__*/React.createElement(Star, backgroundProps), /*#__PURE__*/React.createElement(Star, backgroundProps), /*#__PURE__*/React.createElement(Star, backgroundProps), /*#__PURE__*/React.createElement(Star, backgroundProps), /*#__PURE__*/React.createElement(Box, {
    overflow: "hidden",
    width: width,
    position: "absolute",
    top: 0,
    left: 0
  }, /*#__PURE__*/React.createElement(Star, foregroundProps), /*#__PURE__*/React.createElement(Star, foregroundProps), /*#__PURE__*/React.createElement(Star, foregroundProps), /*#__PURE__*/React.createElement(Star, foregroundProps), /*#__PURE__*/React.createElement(Star, foregroundProps))));
};
StarRating.propTypes = {
  rating: propTypes.number,
  size: propTypes.number
};
var getStarProps = function getStarProps(_ref2) {
  var index = _ref2.index,
    hoverIndex = _ref2.hoverIndex,
    value = _ref2.value;
  var props = {};
  if (hoverIndex >= index) {
    props.fill = 'scheme.controlHover';
  }
  if (value >= index) {
    props.fill = 'scheme.controlActive';
  }
  return props;
};
var RatingInput = function RatingInput(_ref3) {
  var _ref3$onChange = _ref3.onChange,
    onChange = _ref3$onChange === void 0 ? function () {} : _ref3$onChange,
    value = _ref3.value;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    hoverIndex = _useState2[0],
    setHoverIndex = _useState2[1];
  var captions = ['0/10 would not recommend.', 'Pretty bad, tbh.', 'Fine.', 'Pretty darn good!', 'Frickin excellent.'];
  var baseProps = {
    width: 8,
    height: 8,
    color: 'scheme.controlActive',
    fill: 'transparent',
    style: {
      transition: 'fill 250ms'
    }
  };
  return /*#__PURE__*/React.createElement(VStack, {
    layout: true,
    align: "start"
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      whiteSpace: 'nowrap'
    },
    onMouseLeave: function onMouseLeave() {
      return setHoverIndex(0);
    }
  }, [1, 2, 3, 4, 5].map(function (index) {
    return /*#__PURE__*/React.createElement(IconButton, {
      variant: "ghost",
      "aria-label": "".concat(index, " stars"),
      key: "star_".concat(index),
      onMouseEnter: function onMouseEnter() {
        setHoverIndex(index);
      },
      onClick: function onClick() {
        return onChange(index);
      },
      icon: /*#__PURE__*/React.createElement(StarIcon, _extends({}, baseProps, getStarProps({
        index: index,
        hoverIndex: hoverIndex,
        value: value
      })))
    });
  })), /*#__PURE__*/React.createElement(FormHelperText, null, /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    color: "scheme.textSecondary"
  }, value > 0 || hoverIndex > 0 ? captions[(hoverIndex || value) - 1] : 'Speak your truth!')));
};
RatingInput.propTypes = {
  onChange: propTypes.func,
  value: propTypes.number
};

export { RatingInput, StarRating };
